import { ReportItem, SceneConfig, Task } from '@models';
import { Assessment, Level } from '@models';

const EXPERT = 0.95;
const INTERMEDIATE = 0.5;

export const assessmentCalculation = (
  taskList: Task[],
  reportItems: ReportItem[],
  sceneConfig: SceneConfig,
): Assessment => {
  const time = reportItems?.filter(
    (item) => item.name === 'Exercise duration',
  )[0];

  const pathItems = reportItems?.filter(
    (item) => item.name !== 'Exercise duration',
  );

  const maxPathScore =
    pathItems?.reduce((acc, item) => acc + item.maxScore, 0) ?? 100;

  const pathScore = pathItems?.reduce((acc, item) => acc + item.score, 0) ?? 0;

  let numberOfTasks = 0;
  let completedTasks = 0;
  let taskCount = false;
  taskList.forEach((task) => {
    if (numberOfTasks === 0 && task.start) {
      numberOfTasks = 1;
      taskCount = true;
    } else if (taskCount && !task.end) {
      numberOfTasks++;
      completedTasks = completedTasks + (task.state === 'completed' ? 1 : 0);
    } else if (task.end) {
      completedTasks = completedTasks + (task.state === 'completed' ? 1 : 0);
      taskCount = false;
    }
  });

  const canceledExercise =
    taskList.length === 0 ||
    taskList.some(
      (task) => task.state === 'upComing' || task.state === 'inProgress',
    );

  const skipFactor = Math.min(
    completedTasks / (numberOfTasks - sceneConfig?.maxSkippableTaks),
    1,
  );

  const correctedTimeValue = (time?.score * skipFactor) / time?.maxScore;
  const correctedPathValue = (pathScore * skipFactor) / maxPathScore;

  const levelValue =
    (correctedTimeValue * time?.maxScore + correctedPathValue * maxPathScore) /
    (time?.maxScore + maxPathScore);

  const level: Level = !canceledExercise
    ? levelValue >= EXPERT
      ? 'expert'
      : levelValue > INTERMEDIATE
        ? 'intermediate'
        : 'beginner'
    : null;

  const timeLevel: Level = !canceledExercise
    ? correctedTimeValue >= EXPERT
      ? 'expert'
      : levelValue > INTERMEDIATE
        ? 'intermediate'
        : 'beginner'
    : null;

  const pathLevel: Level = !canceledExercise
    ? correctedTimeValue >= EXPERT
      ? 'expert'
      : levelValue > INTERMEDIATE
        ? 'intermediate'
        : 'beginner'
    : null;

  const canceledText = canceledExercise
    ? 'Try to complete all your tasks to receive a proficiency assessment!'
    : null;

  const penalties = [];

  if (time?.score < time?.maxScore) {
    penalties.push('Exercise duration');
  }
  if (pathScore < maxPathScore) {
    penalties.push('Instruments path');
  }
  if (skipFactor < 1) {
    penalties.push('Incomplete tasks');
  }

  const penaltyText =
    penalties.length > 0
      ? 'Your assessment was reduced due to: ' + penalties.join(' | ')
      : null;

  return {
    level,
    timeLevel,
    pathLevel,
    canceledText,
    penaltyText,
    score: levelValue,
  };
};
